export default "__VITE_ASSET__CrDFJDSS__"